import type { PreviewChannelResult } from '../../../types/backend';

type ContentSource = PreviewChannelResult['sources'][string];

const SOURCE_LABELS: Record<ContentSource, string> = {
  prompt: 'AI reworded',
  template: 'AI',
  mapping: 'Field mapping',
  static: 'Fixed text',
};

/** One chip per distinct source; keys are named only when the fields differ. */
export function sourceChips(sources: PreviewChannelResult['sources']): string[] {
  const entries = Object.entries(sources);
  if (entries.length === 0) return ['Not produced'];
  const distinct = new Set(entries.map(([, source]) => source));
  if (distinct.size === 1) {
    const [only] = distinct;
    return [SOURCE_LABELS[only]];
  }
  return entries.map(([key, source]) => `${key}: ${SOURCE_LABELS[source]}`);
}
